import { defineWebModule } from '@nexus/core-web';
import { de } from '../i18n/de';
import { en } from '../i18n/en';
import { manifest } from '../manifest';

/** Listed in apps/web/src/modules.ts. Pages load on first visit, each module is its own bundle. */
export const webModule = defineWebModule({
  manifest,
  messages: { de, en },
  pages: [
    {
      path: '/appointments',
      load: () => import('./appointments-page'),
      permission: 'appointments.appointment.read',
    },
    {
      path: '/appointments/$id',
      load: () => import('./appointment-page'),
      permission: 'appointments.appointment.read',
    },
  ],
  recordSections: [
    {
      key: 'appointments.project-appointments',
      load: () => import('./sections').then((m) => ({ default: m.ProjectAppointmentsSection })),
    },
    {
      key: 'appointments.object-appointments',
      load: () => import('./sections').then((m) => ({ default: m.ObjectAppointmentsSection })),
    },
  ],
  dashboard: [
    {
      key: 'appointments.mine',
      load: () => import('./tiles').then((m) => ({ default: m.MyAppointmentsTile })),
    },
    {
      key: 'appointments.open',
      load: () => import('./tiles').then((m) => ({ default: m.OpenAppointmentsTile })),
    },
  ],
  guides: [
    {
      id: 'appointments.appointments',
      title: 'appointments.guides.appointments.title',
      summary: 'appointments.guides.appointments.summary',
      pages: ['/appointments', '/appointments/$id'],
      content: {
        de: () => import('./guides/appointments.de.md?raw'),
        en: () => import('./guides/appointments.en.md?raw'),
      },
    },
  ],
});
